/**
 * Determine whether a set of navigation item description objects contains an 'active' item, recursively
 * @param items List of NavigationItems
 */
export const hasActiveItem = (items) => {
    return items.some((item) => item.isActive || hasActiveItem(item.subItems));
};
/**
 * A simple and inelegant random ID generator, for use in HTML and not any context where security matters ;)
 */
export const getRandomId = () => String(Math.random()).slice(2);
